import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const LazyMeetingSignalTitleNudge: LoadableType<{
	spaceKey: string;
	contentId: string;
	title?: string | null;
	titleAfterBlur: string | null;
	isLivePage: boolean;
	isUnpublishedDraft: boolean;
	version?: number;
}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-MeetingSignalTitleNudge" */ './MeetingSignalTitleNudge.tsx'
			)
		).MeetingSignalTitleNudge,
});
